import { FileUploadResponse } from '@/interface/file';
import { nextApiRequest } from '@/utils/request';

// 首页行业调查报告
export async function uploadFile(data: FormData) {
  return nextApiRequest.request<FileUploadResponse, FileUploadResponse>({
    // headers: { 'content-type': 'application/x-www-form-urlencoded' },
    headers: { 'Content-Type': 'multipart/form-data' },
    url: '/file/upload',
    method: 'post',
    data,
  });
}
